import React from 'react';

const links = [
  { href: '#hero', label: 'Início' },
  { href: '#desafios', label: 'Desafios' },
  { href: '/plataforma', label: 'Como funciona', external: true },
  { href: '#planos', label: 'Planos' },
  { href: '#casos', label: 'Casos de Sucesso' },
  { href: '#contato', label: 'Contato' },
];

const scrollTo = href => document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });

const Footer = () => (
  <footer className="bg-gray-950 text-white pt-16 pb-8">
    <div className="container mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
        <div className="md:col-span-1">
          <img
            src="https://i.postimg.cc/1tVqPD4T/Prancheta-8-8.png"
            alt="Nexus"
            className="h-9 w-auto object-contain mb-5 brightness-0 invert"
          />
          <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
            Transformando organizações públicas com tecnologia de ponta, facilitando processos e melhorando a vida de servidores e cidadãos.
          </p>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-5">Links Rápidos</h3>
          <ul className="space-y-3">
            {links.map(({ href, label, external }) => (
              <li key={href}>
                <a
                  href={href}
                  onClick={external ? undefined : e => { e.preventDefault(); scrollTo(href); }}
                  className="text-gray-400 hover:text-white text-sm transition-colors duration-200 hover:translate-x-0.5 inline-block"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-5">Contato</h3>
          <ul className="space-y-4 text-sm text-gray-400">
            {[
              {
                icon: 'M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884zM18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z',
                text: 'gestao@carnaubahub.com',
              },
              {
                icon: 'M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z',
                text: '(86) 98170-4823',
              },
              {
                icon: 'M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z',
                text: 'Teresina, Piauí',
              },
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3">
                <div className="w-8 h-8 bg-white/5 rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d={item.icon} fillRule="evenodd" clipRule="evenodd" />
                  </svg>
                </div>
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-xs">
        <p>&copy; {new Date().getFullYear()} CarnaúbaHUB. CNPJ 55.313.572/0001-12 · Teresina, PI. Todos os direitos reservados.</p>
        <div className="flex items-center gap-5">
          <a href="/termos" className="hover:text-white transition-colors">Termos de Uso</a>
          <a href="/privacidade" className="hover:text-white transition-colors">Privacidade</a>
          <a href="/admin" className="transition-colors hover:opacity-80" style={{ color: '#F47920' }}>Área Administrativa</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
